export default __webpack_public_path__ + "static/media/node_chat.fc7aecc9.JPG";